import { render, staticRenderFns } from "./market.vue?vue&type=template&id=fce65afc&scoped=true&"
import script from "./market.vue?vue&type=script&lang=js&"
export * from "./market.vue?vue&type=script&lang=js&"
import style0 from "./market.vue?vue&type=style&index=0&id=fce65afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce65afc",
  null
  
)

export default component.exports